import { Container } from "react-bootstrap";
import "../style/skils.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export default function Skils(){
    const navigate = useNavigate();
    const [activeLink, setActiveLink] = useState(""); // حالة لتخزين الرابط النشط
  
    const handleClick = (e, path) => {
      e.preventDefault(); // منع إعادة تحميل الصفحة
      setActiveLink(path); // تحديث المسار النشط
      navigate(path); // التنقل باستخدام React Router
    };
    return(<div className="skils">
<Container>
    <div className="inside-skils">
        <div className="i-s-l">
            <img className="frist" src="/images/skils1.png" alt="" />
            <img className="second" src="/images/skils2.png" alt="" />
        </div>
        <div className="i-s-r">
            <h2>Willkommen bei unserer<br/> professionellen Reinigungsfirma!</h2>
            <p>Wir bringen Ihre Räume zum Strahlen! Professionelles und zuverlässiges Reinigungsunternehmen mit erstklassigen Lösungen für Privathaushalte und Unternehmen. Zufriedenheit garantiert!</p>
            <div className="i-s-r-i-all">
                <div className="col">
                    <div><i class="fa-solid fa-circle-check"></i> Geprüfte Profis</div>
                    <div><i class="fa-solid fa-circle-check"></i> Verfügbarkeit am nächsten Tag</div>
                    <div><i class="fa-solid fa-circle-check"></i> Standard-Reinigungsaufgaben</div>
                    <div><i class="fa-solid fa-circle-check"></i> Maximale Sauberkeit</div>
                    <div><i class="fa-solid fa-circle-check"></i> Effiziente Reinigung</div>
                </div>
                <div className="col">
                    <div><i class="fa-solid fa-circle-check"></i> Erschwingliche Preise</div>
                    <div><i class="fa-solid fa-circle-check"></i> Beste Qualität</div>
                    <div><i class="fa-solid fa-circle-check"></i> Affordable Prices</div>
                    <div><i class="fa-solid fa-circle-check"></i> Starke Kundenbindung</div>
                    <div><i class="fa-solid fa-circle-check"></i> Gezieltes Wachstum</div>
                </div>
            </div>
            <button onClick={(e) => handleClick(e, "/contact")} className="s-btn">Kontaktieren Sie uns</button>
        </div>
    </div>
</Container>

    </div>);
}